import useOrgsOptions from 'app/hooks/useOrgsOptions';
import { Role } from 'api/Users/types';
import usePaginationParams from 'app/hooks/usePaginationParams';
import { FilterParams } from 'app/types/Filters';
import { SelectOption } from 'app/types/Forms';
import { serviceTypeOptions } from 'components/Dashboard/Billing/helpers';
import { useNamedModels } from 'components/Dashboard/Orgs/Wizard/OrgModels/hooks';
import { FilterProps } from 'components/Dashboard/types';
import { selectModelsApi } from 'store/exec/execSlice';
import { useAppSelector } from 'store/hooks';
import { selectMyUser } from 'store/users/usersSlice';

import { Button, Form, Select, Space } from 'antd';
import React, { useEffect, useMemo } from 'react';

const CreditTariffsFilter: React.FC<FilterProps> = ({ onApply, orgId }) => {
  const { role: myUserRole } = useAppSelector(selectMyUser);
  const modelsApi = useAppSelector(selectModelsApi);
  const { isLoading, namedModels, fetchNamedModels } = useNamedModels();
  const [ form ] = Form.useForm<FilterParams>();
  const {
    orgParam,
    creditServiceTypeParam,
    modelParam,
    modelApiParam,
    setFilters,
    clearFilters,
  } = usePaginationParams();
  const { orgsIdsOptions } = useOrgsOptions();

  useEffect(() => {
    const abortController = new AbortController();
    fetchNamedModels(undefined, abortController);

    return () => {
      abortController.abort();
    };
  }, [ fetchNamedModels ]);

  const namedModelOptions: SelectOption[] = useMemo(
    () => namedModels.map(m => ({ label: m.modelName, value: m.modelName })),
    [ namedModels ],
  );

  const onReset = () => {
    form.setFieldValue('org', []);
    form.setFieldValue('creditServiceType', undefined);
    form.setFieldValue('model', []);
    form.setFieldValue('modelApi', undefined);
    clearFilters();
  };

  const onFinish = (values: FilterParams) => {
    setFilters(values);
    onApply();
  };

  return (
    <Form
      form={form}
      name="creditTariffsFilter"
      layout="vertical"
      requiredMark={false}
      onFinish={onFinish}
      style={{ width: 290 }}
      initialValues={{
        org: orgParam !== '' ? orgParam.split(',') : [],
        creditServiceType: creditServiceTypeParam || undefined,
        model: modelParam !== '' ? modelParam.split(',') : undefined,
        modelApi: modelApiParam || undefined,
      }}
    >
      {myUserRole === Role.SYSTEM_ADMIN && !orgId && (
        <Form.Item name="org" label="Organizations">
          <Select placeholder="Select organizations" mode="multiple" options={orgsIdsOptions} />
        </Form.Item>
      )}

      <Form.Item name="creditServiceType" label="Service type">
        <Select placeholder="Select status" options={serviceTypeOptions} allowClear />
      </Form.Item>

      <Form.Item name="model" label="Model">
        <Select placeholder="Select model" mode="multiple" options={namedModelOptions} allowClear loading={isLoading} />
      </Form.Item>

      <Form.Item name="modelApi" label="Model API">
        <Select placeholder="Select model API" options={modelsApi} allowClear />
      </Form.Item>

      <Form.Item style={{ textAlign: 'right', marginBottom: 0 }}>
        <Space>
          <Button onClick={onReset}>
            Reset
          </Button>
          <Button type="primary" htmlType="submit">
            Apply
          </Button>
        </Space>
      </Form.Item>
    </Form>
  );
};

export default CreditTariffsFilter;
